export default __webpack_public_path__ + "star-1.png";